<script lang="ts">
	import ArticleCard from '../cards/ArticleCard.svelte';
	import TabletSwipeableWrapper from '../layouts/TabletSwipeableWrapper.svelte';
	export let articles;
	export let title;
	export let classNames;
	export let numberGrid = 4;
</script>

{#if articles}
	<div class={classNames}>
		<h3 class="font-bold text-4xl md:text-left text-center">{title}</h3>
		<TabletSwipeableWrapper classNames={`flex lg:grid lg:grid-cols-${numberGrid} gap-[20px] mr-0`}>
			{#each articles as article}
				<ArticleCard {article} />
			{/each}
		</TabletSwipeableWrapper>
	</div>
{/if}

<style>
	.postContainer {
		grid-template-columns: 25% 75%;
	}
</style>
